import React from 'react'

import MetadataLabel from './MetadataLabel'
import { useI18N } from '../../../libraries/i18n/hook'

const MAX_AUTHORS_SHOWN = 3
type Props = { authors: string[], strokeColor?: string, lineClamp?: number }
const AuthorsLabel: React.FC<Props> = ({ authors, strokeColor, lineClamp }) => {
  const { t } = useI18N()
  let formattedAuthors = authors
  let authorsHidden = 0
  if(authors.length > MAX_AUTHORS_SHOWN) {
    formattedAuthors = formattedAuthors.slice(0, MAX_AUTHORS_SHOWN)
    authorsHidden = authors.length - MAX_AUTHORS_SHOWN
  }
  return (
    <div className='inline-block text-2xs sm:text-xs'>
      <MetadataLabel icon='author' strokeColor={strokeColor} lineClamp={lineClamp}>
        {formattedAuthors.toString().replace(/,/g, ', ')}
        {authorsHidden > 0 && `, ${authorsHidden} ${t('content.moreAuthors')}...`}
      </MetadataLabel>
    </div>
  )
}

export default AuthorsLabel
